// flow
import { useEffect, useRef } from "react";

export default function useEffectOnUnmount(effect: () => void) {
  const effectRef = useRef(effect);

  useEffect(() => {
    effectRef.current = effect;
  }, [effect]);

  useEffect(() => {
    return () => effectRef.current && effectRef.current();
  }, []);
}
